var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMrVrPhysicalTrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10L10.295 10.705L12.085 12.5H4C3.46957 12.5 2.96086 12.2893 2.58579 11.9142C2.21071 11.5391 2 11.0304 2 10.5C2 9.96957 2.21071 9.46086 2.58579 9.08579C2.96086 8.71071 3.46957 8.5 4 8.5H10C10.7956 8.5 11.5587 8.18393 12.1213 7.62132C12.6839 7.05871 13 6.29565 13 5.5C13 4.70435 12.6839 3.94129 12.1213 3.37868C11.5587 2.81607 10.7956 2.5 10 2.5H1.915L3.705 0.705L3 0L0 3L3 6L3.705 5.295L1.915 3.5H10C10.5304 3.5 11.0391 3.71071 11.4142 4.08579C11.7893 4.46086 12 4.96957 12 5.5C12 6.03043 11.7893 6.53914 11.4142 6.91421C11.0391 7.28929 10.5304 7.5 10 7.5H4C3.20435 7.5 2.44129 7.81607 1.87868 8.37868C1.31607 8.94129 1 9.70435 1 10.5C1 11.2956 1.31607 12.0587 1.87868 12.6213C2.44129 13.1839 3.20435 13.5 4 13.5H12.085L10.295 15.295L11 16L14 13L11 10Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrVrPhysicalTrack);
export default __webpack_public_path__ + "static/media/mr-vr-physicalTrack.229f70587f278e729712eebcf16559d6.svg";
export { ForwardRef as ReactComponent };